
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("lu6uO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Trackers", () => $c7da247ef80934f6$export$a2c5350cd99575c4);
$parcel$export(module.exports, "default", () => $c7da247ef80934f6$export$2e2bcd8739ae039);

var $eV0yY = parcelRequire("eV0yY");

var $jWmL9 = parcelRequire("jWmL9");
const $c7da247ef80934f6$export$a2c5350cd99575c4 = ()=>{
    (0, $eV0yY.useProjectContextReporter)();
    (0, $jWmL9.useRecentProjectTracker)();
    return null;
};
var $c7da247ef80934f6$export$2e2bcd8739ae039 = $c7da247ef80934f6$export$a2c5350cd99575c4;

});
parcelRegister("eV0yY", function(module, exports) {
$parcel$export(module.exports, "useProjectContextReporter", () => $9e36c613cd14d95b$export$57c2053bbe217389);

var $eJOHy = parcelRequire("eJOHy");

var $eWzpp = parcelRequire("eWzpp");

var $kRgKj = parcelRequire("kRgKj");
var $iFaP4 = parcelRequire("iFaP4");
const $9e36c613cd14d95b$var$convertToAnalyticsProjectType = (projectType)=>projectType === 'service_desk' ? 'serviceDesk' : projectType;
const $9e36c613cd14d95b$export$57c2053bbe217389 = ()=>{
    const { data: project } = (0, $eWzpp.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iFaP4.useAnalyticsEvents)();
    const projectId = project?.id;
    const projectType = project?.type;
    const isSimplified = project?.isSimplified;
    (0, $eJOHy.useEffect)(()=>{
        if (projectId == null || projectType == null) return;
        const event = createAnalyticsEvent({});
        (0, $kRgKj.fireOperationalAnalytics)(event, 'projectContainer entered', {
            projectId: projectId,
            projectType: $9e36c613cd14d95b$var$convertToAnalyticsProjectType(projectType),
            nextGenProject: isSimplified
        });
    }, [
        createAnalyticsEvent,
        projectId,
        projectType,
        isSimplified
    ]);
};

});

parcelRegister("jWmL9", function(module, exports) {
$parcel$export(module.exports, "useRecentProjectTracker", () => $3b0f5e86529f14c0$export$89d3183f2c4acebd);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $eSnSE = parcelRequire("eSnSE");

var $eBhI6 = parcelRequire("eBhI6");

var $eWzpp = parcelRequire("eWzpp");

var $kh7bJ = parcelRequire("kh7bJ");
const $3b0f5e86529f14c0$export$89d3183f2c4acebd = ()=>{
    (0, $gRw8I.di)(fetch);
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const { data: project } = (0, $eWzpp.useProject)();
    const projectKey = project?.key;
    (0, $eJOHy.useEffect)(()=>{
        if (isAnonymous || projectKey == null) return;
        const url = `/rest/api/latest/project/${encodeURIComponent(projectKey)}/tracking/recent`;
        fetch(url, {
            ...(0, $eBhI6.getDefaultOptions)(url),
            method: 'PUT'
        }).then((response)=>{
            if (response.ok) return response;
            throw new Error(`Server didn't accept "${projectKey}", status code: ${response.status}`);
        }).catch((e)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData('project-layout.use-recent-project-tracker', 'There was a problem saving recent visited project', e);
        });
    }, [
        isAnonymous,
        projectKey
    ]);
};

});
parcelRegister("kh7bJ", function(module, exports) {
$parcel$export(module.exports, "useIsAnonymous", () => $823c6492726fd885$export$bf7b5d502f6d6d3b);

var $koAZ4 = parcelRequire("koAZ4");
const $823c6492726fd885$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});




//# sourceMappingURL=async-project-trackers.964eee28.js.map
